
export const fetchBillingByAppointment = async (apptId, userID, signal) => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/billing/${apptId}?userID=${userID}`, {
    signal,
  });
  if (!response.ok) {
    throw new Error("Failed to fetch billing codes");
  }

  const result = await response.json();
  if (
    result?.success === true &&
    Object.prototype.hasOwnProperty.call(result, "data")
  ) {
    return result.data;
  }

  return result;
};

export const updateBillingByAppointment = async (apptId, userID, updatedCodes) => {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/api/billing/${apptId}?username=${userID}`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ billing_codes: updatedCodes })
    }
  );

  if (!response.ok) {
    throw new Error("Failed to update billing codes");
  }

  return response.json();
};